export const baseApi = 'https://1test.cabinet.energy/admin'
